import React from "react";
import {
  Container,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
  Card,
  CardBody,
  CardTitle,
  Alert,
} from "reactstrap";

import "./styles/qr.css";
import usePersistedState from "./hooks/usePersistedState";
import { validateUrl } from "./utils/validateUrl";
import QRControls from "./components/QRControls";
import QRPreview from "./components/QRPreview";
import QRDownloadButtons from "./components/QRDownloadButtons";

const DEFAULTS = {
  url: "",
  size: 256,
  margin: 4,
  ecc: "M", // L,M,Q,H
  fgColor: "#000000",
  bgColor: "#ffffff",
  logoDataUrl: "", // base64 data URL
};

const QRGeneratorPage = () => {
  const [settings, setSettings] = usePersistedState("qrgen.settings", DEFAULTS);
  const [error, setError] = React.useState("");

  const isValid = validateUrl(settings.url);

  React.useEffect(() => {
    setError("");
  }, [settings.url]);

  const handleChange = (partial) => {
    setSettings((prev) => ({ ...prev, ...partial }));
  };

  const handleReset = () => setSettings(DEFAULTS);

  const tryGenerate = () => {
    if (!isValid) {
      setError("โปรดกรอก URL ที่ขึ้นต้นด้วย http:// หรือ https://");
      return false;
    }
    return true;
  };

  return (
    <Container>
      <br />
      <Breadcrumb>
        <BreadcrumbItem>
          <a href="/">หน้าหลัก</a>
        </BreadcrumbItem>
        <BreadcrumbItem active>QR Code Generator</BreadcrumbItem>
      </Breadcrumb>

      <Row>
        <Col md="12" lg="10">
          <Card>
            <CardBody>
              <CardTitle tag="h5">QR Code Generator</CardTitle>
              <p className="text-muted" style={{ marginBottom: 12 }}>
                สร้าง QR สำหรับลิงก์ URL —
                ปรับขนาด/สี/ขอบ/ระดับการแก้ไขข้อผิดพลาด และสามารถฝังโลโก้ได้
              </p>

              {error && (
                <Alert color="danger" className="mb-3">
                  {error}
                </Alert>
              )}

              <Row className="gy-4">
                <Col md="6" lg="5">
                  <QRControls
                    value={settings}
                    onChange={handleChange}
                    onReset={handleReset}
                  />
                </Col>

                <Col md="6" lg="7">
                  <QRPreview value={settings} isValid={isValid} />
                  <QRDownloadButtons
                    value={settings}
                    onBeforeGenerate={tryGenerate}
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default QRGeneratorPage;
